var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 5.16663L10.6667 8.49996L15.3333 11.8333V5.16663Z",
    stroke: "#A9CF3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 3.83337H1.99999C1.26361 3.83337 0.666656 4.43033 0.666656 5.16671V11.8334C0.666656 12.5698 1.26361 13.1667 1.99999 13.1667H9.33332C10.0697 13.1667 10.6667 12.5698 10.6667 11.8334V5.16671C10.6667 4.43033 10.0697 3.83337 9.33332 3.83337Z",
    stroke: "#A9CF3D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingVideoIcon);
export default __webpack_public_path__ + "static/media/incoming_video_icon.b285797a58974e2c314f3797d55e731b.svg";
export { ForwardRef as ReactComponent };